var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scroll-box", {
    attrs: {
      data: _vm.data,
      loading: _vm.loading,
      total: _vm.total,
      showMore: _vm.showMore
    },
    on: {
      loadMore: function($event) {
        return _vm.$emit("loadMore")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function(scope) {
          return [
            _c("img-record", { attrs: { src: scope.row.imgUrl, type: "left" } })
          ]
        }
      },
      {
        key: "right",
        fn: function(scope) {
          return [
            _c("img-record", {
              attrs: { src: scope.row.imgUrl, type: "right" }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }